export class AnimationGroup {
    constructor() {
        this.members = new Set();
        this.clips = new Map();
        this.selectedId = null;
        this.initialized = false;
        this.playing = true;
        this.loop = true;
    }
    get animationClipInfo() {
        const info = new Map();
        for (const member of this.members) {
            for (const clip of member.animationClipInfo)
                info.set(clip.key, clip);
        }
        return [...info.values()].sort((a, b) => Number(a.key.split(":")[1]) - Number(b.key.split(":")[1]));
    }
    applyAnimationState(state) {
        this.state = state;
        this.selectedId = state.clipKey;
        this.loop = state.loop;
        this.playing = state.playing;
        for (const member of this.members)
            member.applyAnimationState(state);
    }
    get isAnimationPlaying() {
        return [...this.members].some((member) => member.isAnimationPlaying);
    }
    get animationLoop() {
        return this.loop;
    }
    get animationClipIds() {
        return [...this.clips.keys()];
    }
    get animationClips() {
        return [...this.clips.values()];
    }
    get selectedAnimationClip() {
        return this.selectedId === null ? null : this.animationClipIds.indexOf(this.selectedId);
    }
    get animationTime() {
        for (const member of this.members) {
            if (member.selectedAnimationClip !== null)
                return member.animationTime;
        }
        return 0;
    }
    get size() {
        return this.members.size;
    }
    add(member) {
        const time = this.animationTime;
        if (this.members.size > 0)
            this.playing = this.isAnimationPlaying;
        member.animationClipIds.forEach((id, index) => {
            this.clips.set(id, member.animationClips[index]);
        });
        if (!this.initialized) {
            this.selectedId = member.selectedAnimationClip === null ? null : member.animationClipIds[member.selectedAnimationClip];
            this.initialized = true;
        }
        this.members.add(member);
        member.setAnimationLoop(this.loop);
        this.selectMember(member, time);
        if (!this.playing)
            member.pauseAnimation();
        if (this.state)
            member.applyAnimationState(this.state);
    }
    remove(member) {
        this.members.delete(member);
        // Retain clip order and the selection while remaining material parts are loaded.
    }
    selectAnimationClip(index) {
        if (index !== null && (!Number.isInteger(index) || index < 0 || index >= this.clips.size)) {
            throw new Error(`[mesh] Invalid animation group clip index: ${index}`);
        }
        this.selectedId = index === null ? null : this.animationClipIds[index];
        this.playing = index !== null;
        for (const member of this.members)
            this.selectMember(member, 0);
    }
    playAnimation() {
        this.playing = this.selectedId !== null;
        for (const member of this.members)
            member.playAnimation();
    }
    pauseAnimation() {
        this.playing = false;
        for (const member of this.members)
            member.pauseAnimation();
    }
    resetAnimation() {
        this.playing = false;
        for (const member of this.members)
            member.resetAnimation();
    }
    setAnimationLoop(loop) {
        this.loop = loop;
        for (const member of this.members)
            member.setAnimationLoop(loop);
    }
    selectMember(member, time) {
        const index = this.selectedId === null ? -1 : member.animationClipIds.indexOf(this.selectedId);
        member.selectAnimationClip(index < 0 ? null : index, time);
    }
}
